@if (!pulse) {
  <span [class.symbol]="isSymbol" [class]="flavor" class="badge">
    @if (isSymbol) {
      <span aria-hidden="true">{{ symbol }}</span>
    }
    <span [class.sr-only]="isSymbol"><ng-content></ng-content></span>
  </span>
}
@if (pulse) {
  <span [class.hidden]="!isSymbol" [class.pulse]="true" [class.symbol]="true" [class]="flavor"
    class="badge">
    @if (isSymbol) {
      <span aria-hidden="true">{{ symbol }}</span>
    }
  </span>
}
